import { render, staticRenderFns } from "./tournamentBrackets.vue?vue&type=template&id=177685c0&scoped=true&"
import script from "./tournamentBrackets.vue?vue&type=script&lang=js&"
export * from "./tournamentBrackets.vue?vue&type=script&lang=js&"
import style0 from "./tournamentBrackets.vue?vue&type=style&index=0&id=177685c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177685c0",
  null
  
)

export default component.exports